import React, { useEffect, useState } from "react";
import { IdxFooter, IdxHeader } from "../component";
import { Router } from "./route";
import Cookies from "js-cookie";
import { Redirect } from "react-router-dom";
import { AuthService, clearAuthSession } from "../service";

function App() {
  const [checkingSession, setCheckingSession] = useState(Boolean(Cookies.get("token")));
  const [authenticated, setAuthenticated] = useState(Boolean(Cookies.get("token")));

  useEffect(() => {
    let mounted = true;

    const validateSession = async () => {
      if (!Cookies.get("token")) {
        if (mounted) {
          setAuthenticated(false);
          setCheckingSession(false);
        }
        return;
      }

      try {
        const response = await AuthService.profile();

        if (!mounted) return;

        if (response?.success) {
          setAuthenticated(true);
        } else {
          clearAuthSession();
          setAuthenticated(false);
        }
      } catch (error) {
        if (!mounted) return;

        clearAuthSession();
        setAuthenticated(false);
      } finally {
        if (mounted) {
          setCheckingSession(false);
        }
      }
    };

    validateSession();

    return () => {
      mounted = false;
    };
  }, []);

  if (checkingSession) {
    return null;
  }

  if (!authenticated) {
    return <Redirect to="/login" />;
  }

  return (
    <React.Fragment>
      {/* Header */}
      <section>
        <IdxHeader />
      </section>
      <section style={{ minHeight: "100vh" }}>
        <Router />
      </section>
      <section>
        <IdxFooter />
      </section>
    </React.Fragment>
  );
}

export default App;
